import React from 'react';
const facts = [{
  value: '6 + 5',
  label: 'Volumes & bonuses'
}, {
  value: '121',
  label: 'Practices ready to run'
}, {
  value: '5',
  label: 'Event groups covered'
}, {
  value: '0',
  label: 'Practices made up on the spot'
}];
export function SocialProofBar() {
  return <section className="w-full bg-navy-mid" data-id="element-484" data-mp="25suaxhshg1mi">
      <div className="mx-auto max-w-6xl px-5 py-10 sm:py-12" data-id="element-485" data-mp="25u5at6it4p8c">
        <div className="grid grid-cols-2 gap-px overflow-hidden rounded-xl border border-navy-line bg-navy-line sm:grid-cols-4" data-id="element-486" data-mp="32iutgz29dlvd">
          {facts.map(fact => <div key={fact.label} className="bg-navy px-4 py-5 text-center" data-id="element-487" data-mp="2xhxcuqwwczvz">
              <div className="font-display text-4xl font-bold leading-none text-hl sm:text-5xl" data-id="element-488" data-mp="2tgvaw2bli9qb">{fact.value}</div>
              <div className="mt-1.5 text-[10px] font-semibold uppercase tracking-widest text-chalk/65" data-id="element-489" data-mp="2oj28zlhbs1vu">{fact.label}</div>
            </div>)}
        </div>
      </div>
    </section>;
}